import { render, staticRenderFns } from "./BadgeLevelNovice.vue?vue&type=template&id=4e9d9a09&scoped=true"
import script from "./BadgeLevelNovice.vue?vue&type=script&lang=js"
export * from "./BadgeLevelNovice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9d9a09",
  null
  
)

export default component.exports